"use client";
import { EnhancedSwiperProps } from "@/commonComponents/enhanced-swiper";
import { MaterialImage } from "@/commonComponents/material-components";
import { Box } from "@mui/material";
import { StaticImageData } from "next/image";
import { Autoplay } from "swiper/modules";
import EnhancedSwiper from "@cc/enhanced-swiper";

interface ImageSliceProps {
  img: StaticImageData | string;
}

const ImageSlice = (props: ImageSliceProps) => {
  const { img } = props;
  return (
    <MaterialImage
      src={img}
      alt=""
      width={421}
      height={267}
      sx={{
        height: { xs: 230, md: 267 },
        objectFit: "cover",
      }}
    />
  );
};

export interface VerticalSwiperProps {
  data: ImageSliceProps[];
}

const VerticalSwiper = (props: VerticalSwiperProps) => {
  const { data } = props;
  return (
    <>
      <Box sx={{ display: "flex", gap: 1 }}>
        <EnhancedSwiper
          data={data}
          SlideComponent={ImageSlice}
          {...swiperProps}
        />

        <EnhancedSwiper
          data={data}
          SlideComponent={ImageSlice}
          {...swiperProps}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: false,
          }}
        />
      </Box>
    </>
  );
};

export default VerticalSwiper;

const swiperProps: Omit<EnhancedSwiperProps, "data" | "SlideComponent"> = {
  slidesPerView: "auto",
  speed: 5000,
  direction: "vertical",
  loop: true,
  modules: [Autoplay],
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    reverseDirection: true,
  },
  SlideWrapperProps: {
    sx: {
      width: "auto",
      height: "max-content",
    },
  },
  sx: {
    width: "100%",
    height: {
      md: 522,
      xs: 290,
    },
    "& .swiper-wrapper": {
      height: {
        md: 522,
        xs: 290,
      },
      transitionTimingFunction: "linear !important",
    },
  },
};
